import { useSWRConfig } from 'swr';
import { useParams } from 'react-router-dom';
import { postFetcher } from '@/api/fetchers';
import type { CreateAbsence } from '@/schemas/API/POST/employee/absence/request';

export default function useCreateAbsence() {
  const { employeeId } = useParams<{ employeeId: string }>();
  const { mutate } = useSWRConfig();

  const createAbsence = async (
    absence: CreateAbsence
  ) => {
    if (!employeeId) throw new Error('employeeId is undefined. Check URL.');

    await postFetcher(
      `/employees/${employeeId}/absences`,
      absence
    );

    await mutate(`/employees/${employeeId}/absences`);
  };

  return {
    createAbsence,
  };
}